import { Chart as ChartJS, ArcElement } from "chart.js";
import { Doughnut } from "react-chartjs-2";
import { useEffect, useRef } from "react";
ChartJS.register(ArcElement);

// active: highlighted slice index (from the chart or the list beside it); onActive reports chart hovers
const PieChart = ({ series, active, onActive, children }) => {
	const ref = useRef(null);

	// a row hovered in the list lights up its slice too
	useEffect(() => {
		const chart = ref.current;
		if (!chart) return;
		chart.setActiveElements(active == null ? [] : [{ datasetIndex: 0, index: active }]);
		chart.update();
	}, [active]);

	return (
		<div className="sales-donut">
			<Doughnut
				ref={ref}
				data={{
					labels: series.map((s) => s.label),
					datasets: [
						{
							data: series.map((s) => s.value),
							backgroundColor: series.map((s) => s.color),
							borderColor: "#fff",
							borderWidth: 3,
							hoverOffset: 8,
							borderRadius: 6,
						},
					],
				}}
				options={{
					cutout: "72%",
					// the canvas fills the square wrapper exactly, so its centre is the centre of the overlay text
					maintainAspectRatio: false,
					layout: { padding: 8 },
					animation: { animateRotate: true, duration: 900 },
					onHover: (_, elements) => onActive(elements.length ? elements[0].index : null),
					plugins: { legend: { display: false }, tooltip: { enabled: false } },
				}}
			/>
			{/* the centre explains the highlighted slice, so no tooltip is needed */}
			<div className="sales-donut-center" aria-live="polite">
				{children}
			</div>
		</div>
	);
};

export default PieChart;
